import moment from "moment";

export const UKETSAER_TABLE_COLUMNS = [
	{
		accessorKey: "ukEtsAerId",
		header: "UK ETS AER ID",
		size: 280,
		enableColumnFilter: false,
		Cell: ({ cell }) => (
			<span style={{ fontWeight: "500" }}>{cell.getValue() || ""}</span>
		),
	},
	{
		accessorKey: "companyImoNumber",
		header: "Company IMO Number",
		size: 160,
	},
	{
		accessorKey: "companyName",
		header: "Company Name",
		size: 200,
		muiTableBodyCellProps: {
			sx: {
				whiteSpace: "pre-line",
				wordWrap: "break-word",
				overflowWrap: "break-word",
			},
		},
	},
	{
		accessorKey: "wcnNumber",
		header: "WCN No",
		size: 100,
	},
	{
		accessorKey: "wcnCompanyName",
		header: "WCN Company Name",
		size: 180,
	},
	{
		accessorKey: "status",
		header: "Status",
		size: 180,
	},
	{
		accessorKey: "submittedDate",
		header: "Submitted Date",
		size: 140,
		enableColumnFilter: false,
		Cell: ({ cell }) => {
			const val = cell.getValue();
			return val ? (
			 <span>{moment.utc(val).format("DD MMM YYYY HH:mm:ss")}</span>
			) : (
				<span></span>
			);
		},
	},
	{
		accessorKey: "reviewer",
		header: "Latest Reviewer",
		size: 200,
	},
	{
		accessorKey: "verifier",
		header: "Latest Verifier",
		size: 200,
	},
];
